import script from "./appGroupTableEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./appGroupTableEdit.vue?vue&type=script&setup=true&lang=js"

import "./appGroupTableEdit.vue?vue&type=style&index=0&id=12a805ab&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12a805ab"]])

export default __exports__